import {
  CONVERTIBLE,
  LIMOUSINE,
  COUPE_SPORT,
  STATION_WAGON,
  SUV_PICKUP,
  VAN_TRANSPORTER,
  SMALL_CAR,
  CONVERTIBLE_COUPE,
  ROADSTER,
} from 'helpers/fieldOptions/car/bodyType';

import ConvertibleBodyTypeIcon from 'components/icons/bodyTypes/ConvertibleBodyTypeIcon.com.svg';
import CoupeSportBodyTypeIcon from 'components/icons/bodyTypes/CoupeSportBodyTypeIcon.com.svg';
import StationWagonBodyTypeIcon from 'components/icons/bodyTypes/StationWagonBodyTypeIcon.com.svg';
import SuvPickupBodyTypeIcon from 'components/icons/bodyTypes/SuvPickupBodyTypeIcon.com.svg';
import VanTransporterBodyTypeIcon from 'components/icons/bodyTypes/VanTransporterBodyTypeIcon.com.svg';
import LimousineBodyTypeIcon from 'components/icons/bodyTypes/LimousineBodyTypeIcon.com.svg';
import SmallCarBodyTypeIcon from 'components/icons/bodyTypes/SmallCarBodyTypeIcon.com.svg';
import ConvertibleCoupeBodyTypeIcon from 'components/icons/bodyTypes/ConvertibleCoupeBodyTypeIcon.com.svg';
import RoadsterBodyTypeIcon from 'components/icons/bodyTypes/RoadsterBodyTypeIcon.com.svg';

export default {
  [CONVERTIBLE]: ConvertibleBodyTypeIcon,
  [COUPE_SPORT]: CoupeSportBodyTypeIcon,
  [LIMOUSINE]: LimousineBodyTypeIcon,
  [STATION_WAGON]: StationWagonBodyTypeIcon,
  [SUV_PICKUP]: SuvPickupBodyTypeIcon,
  [VAN_TRANSPORTER]: VanTransporterBodyTypeIcon,
  [SMALL_CAR]: SmallCarBodyTypeIcon,
  [CONVERTIBLE_COUPE]: ConvertibleCoupeBodyTypeIcon,
  [ROADSTER]: RoadsterBodyTypeIcon,
};
